import {
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  input,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ImmomioIconName, removeHTML } from '@resident-nx/shared';
import { Elevation, ElevationType, ImageWebComponent } from '@resident-nx/web/ui';
import { ContentCardPreset } from './content-card.model';
import { DateTransformPipe } from '../../../pipes/date.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { IconWebComponent } from '@resident-nx/web/ui';
import { NgClass } from '@angular/common';
import {
  CenterImageSizeEnum,
  ImageBorderRadiusEnum,
  ImageObjectFitEnum,
  ImageBorderStyleEnum,
} from '@resident-nx/web/util';

@Component({
  selector: 'rs-web-content-card',
  templateUrl: './content-card.component.html',
  styleUrls: ['./content-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImageWebComponent, NgClass, IconWebComponent, TranslatePipe, DateTransformPipe],
})
export class ContentCardWebComponent implements OnInit {
  @Input() elevation: ElevationType = Elevation.THREE;
  @Input() hover = true;
  @Input() textOverflow = true;
  @Input() id: string;
  @Input() title: string;
  @Input() text: string;
  @Input() date: string;
  @Input() preset: ContentCardPreset = null;
  @Input() pinned = false;
  @Output() tapped = new EventEmitter<string>();
  readonly image = input<string>();
  /**
   * Whether an image is expected, known before `image` itself resolves. Set it when `image` is
   * bound to an asynchronous source so the slot can reserve its space instead of popping in.
   * Defaults to the presence of `image` for callers passing a static source.
   */
  readonly hasImage = input<boolean | null>(null);
  readonly showImageSlot = computed(() => this.hasImage() ?? !!this.image());
  public imageObjectFit: ImageObjectFitEnum;
  public imageBoarderRadius: ImageBorderRadiusEnum;
  public imageBorderStyle: ImageBorderStyleEnum;
  public immomioIconName = ImmomioIconName;
  public footerIcon: ImmomioIconName;
  public centerImageSize: CenterImageSizeEnum;
  public presets = ContentCardPreset;

  ngOnInit(): void {
    switch (this.preset) {
      case ContentCardPreset.ANNOUNCEMENT:
        this.footerIcon = ImmomioIconName.Clock;
        break;
      case ContentCardPreset.NEWS:
        this.footerIcon = ImmomioIconName.Calendar;
        this.imageObjectFit = ImageObjectFitEnum.CONTAINS;
        this.imageBoarderRadius = ImageBorderRadiusEnum.ROUND;
        this.imageBorderStyle = ImageBorderStyleEnum.ROUNDED;
        this.centerImageSize = CenterImageSizeEnum.M;
        break;
      default:
        this.footerIcon = ImmomioIconName.Clock;
        this.imageObjectFit = ImageObjectFitEnum.COVER;
        this.imageBoarderRadius = null;
        this.imageBorderStyle = null;
        break;
    }
  }

  public removeHTML = removeHTML;

  public tap(): void {
    this.tapped.emit(this.id);
  }
}
